'use client'

import { useMemo } from 'react'

import Carousel from './Carousel'

const testimonials = [
  {
    name: 'Andre L',
    title: 'Civil Engineer',
    age: 42,
    text: "XNNFIT didn't just give me a fitness plan. It helped me build habits that actually last. I feel stronger—physically and mentally.",
    image: '/testimonial-andre.png',
  },
  {
    name: 'Thomas B',
    title: 'High School Teacher',
    age: 45,
    text: "I've tried other programs before, but this is the first that made me feel seen and supported. The results speak for themselves.",
    image: '/testimonial-thomas.png',
  },
  {
    name: 'Raymond T',
    title: 'Software Developer',
    age: 37,
    text: 'With my tight schedule, I needed something realistic. XNNFIT gave me a program that fits my life, not the other way around.',
    image: '/testimonial-raymond.png',
  },
  {
    name: 'Marketing Specialist',
    title: 'Marketing Specialist',
    age: 34,
    text: 'I used to struggle with consistency, but my coach helped me stay on track. The support feels human, not robotic.',
    image: '/testimonial-marketing.png',
  },
]

export default function TestimonialsSection() {
  const slides = useMemo(
    () =>
      testimonials.map((testimonial, index) => (
        <div
          key={index}
          className="rounded-[16px] border border-[#1a2d4d] bg-[#0a1628] p-[40px] shadow-lg transition-shadow hover:shadow-xl hover:shadow-[#0C4A98]/10"
        >
          {/* Header with Profile */}
          <div className="mb-[24px] flex items-center gap-[20px]">
            {/* Profile Picture Placeholder */}
            <div className="h-[72px] w-[72px] flex-shrink-0 rounded-full bg-gradient-to-br from-[#0C4A98] to-[#27D3ED] shadow-md" />

            <div>
              <h3 className="mb-[6px] text-[20px] font-bold text-FFFFFF">
                {testimonial.name}
              </h3>
              <p className="text-[15px] text-[#D5D9DD]">
                {testimonial.title}, {testimonial.age}
              </p>
            </div>
          </div>

          {/* Separator */}
          <div className="mb-[28px] h-[1px] bg-gradient-to-r from-transparent via-[#1a2d4d] to-transparent" />

          {/* Testimonial Text */}
          <p className="text-[17px] leading-[1.7] text-[#FFFFFF]">
            {testimonial.text}
          </p>
        </div>
      )),
    [],
  )

  return (
    <div
      id="testimonials"
      className="mt-[180px] desktop:grid desktop:grid-cols-2 desktop:gap-0"
    >
      {/* Left/Mobile Top Section - Hero with Image */}
      <div className="relative flex h-[350px] items-center justify-center bg-[url(/testimonials.png)] bg-cover bg-center desktop:h-[500px]">
        {/* Dark overlay */}
        <div className="bg-black/60 absolute inset-0" />

        {/* Content */}
        <div className="relative z-10 w-full px-[20px] desktop:px-[60px] desktop:py-[60px]">
          {/* Main Heading */}
          <div className="absolute bottom-[40px] left-[20px] desktop:bottom-[80px] desktop:left-[60px]">
            <div className="relative mb-[20px] inline-block desktop:mb-[28px]">
              <h2 className="mb-[12px] font-oswald text-[32px] leading-tight font-bold text-FFFFFF uppercase desktop:mb-[16px] desktop:text-[56px]">
                REAL PEOPLE.
              </h2>
              {/* Blue underline */}
              <div className="absolute -bottom-[8px] left-[50%] h-[3px] w-[140%] -translate-x-[50%] bg-[#27D3ED]" />
            </div>

            <div className="relative inline-block">
              <h2 className="font-oswald text-[32px] leading-tight font-bold text-FFFFFF uppercase desktop:text-[56px]">
                REAL RESULTS.
              </h2>
              {/* Blue underline */}
              <div className="absolute -bottom-[8px] left-[50%] h-[3px] w-[140%] -translate-x-[50%] bg-[#27D3ED]" />
            </div>
          </div>
        </div>
      </div>

      {/* Right/Bottom Section - Testimonials */}
      <div className="relative bg-[#020e20] px-[20px] py-[80px] desktop:px-[60px] desktop:py-[120px]">
        {/* Testimonials Container */}
        <div>
          <Carousel
            slidesPerView={{ mobile: 1, desktop: 2 }}
            gap={32}
            showDots={true}
            showArrows={false}
          >
            {slides}
          </Carousel>
        </div>
      </div>
    </div>
  )
}
